var projectTimeline = {
	"Project timeline": "Proje Zaman Çizelgesi",
	"None planned": "Planlanmadı",
	"1-3 months": "1-3 Ay",
	"4-6 months": "4-6 Ay",
	"7-12 months": "7-12 Ay",
	"More than 1 year": "1 Yıldan Fazla"
};

export { projectTimeline as default };
